import Box from '@mui/material/Box';
import React from 'react';
import { RATERS, SPACE } from '@/constants';
import { ALERT_STATUSES } from '@/constants/statuses';
import Alert from '@/components/alert';

type SaferPickBannerProps = {
  ratingProvider?: (typeof RATERS)[keyof typeof RATERS];
  isSaferPick?: boolean;
};

const SaferPickBanner = ({ ratingProvider, isSaferPick }: SaferPickBannerProps) => {
  if (ratingProvider !== RATERS.UCSR || !isSaferPick) {
    return null;
  }
  return (
    <Box mb={SPACE.X2}>
      <Alert status={ALERT_STATUSES.saferPick} />
    </Box>
  );
};

export default SaferPickBanner;
